import React from 'react';

import { FullLoader } from '@ge/components/loader';
import { signinSilentCallback } from '@ge/shared/services/auth';

export const SilentRenew = () => {
  signinSilentCallback();
  return <FullLoader />;
};
